import { useState } from 'react';

import LinkOffIcon from '@mui/icons-material/LinkOff';
import { Grid, Typography } from '@mui/material';
import { Button, Confirm, HttpError, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { UnlinkAccountBodyDto } from 'src/dtos';
import { HttpErrorTypography } from 'src/lib';
import { BaseAccount } from 'src/models';

export const UnlinkAdditionalAccountButton = ({
  account,
  rootAccountId,
}: {
  account?: BaseAccount;
  rootAccountId?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const [unlinkAccount, { isError, error, isLoading, reset }] = useUpdate<
    Partial<UnlinkAccountBodyDto> & { id: string },
    HttpError
  >();

  const onConfirm = () => {
    unlinkAccount(
      DataProviderResource.UnlinkAccount,
      {
        id: rootAccountId,
        data: {
          id: account?.id,
        },
      },
      {
        mutationMode: 'pessimistic',
        onSuccess: () => {
          notify(`Additional account was successfully unlinked.`, {
            type: 'success',
            undoable: true,
          });
          onClose();
        },
        onSettled: () => {
          refresh();
        },
      },
    );
  };

  const onClose = () => {
    setIsOpen(false);
    reset();
  };

  return (
    <>
      <Button label='Unlink' onClick={() => setIsOpen(true)} startIcon={<LinkOffIcon />} disabled={isLoading} />
      <Confirm
        isOpen={isOpen}
        title='Unlink Additional Account'
        content={
          <Grid container direction='column' spacing={2}>
            <Grid item md={12} sm={12}>
              <Typography variant='body1'>
                Are you sure you want to unlink {account?.customTypeLabel} additional account?
              </Typography>
              {isError && <HttpErrorTypography error={error} />}
            </Grid>
          </Grid>
        }
        onConfirm={onConfirm}
        onClose={onClose}
        loading={isLoading}
      />
    </>
  );
};
